
<template>
 <component :is="layout">
   <Spinner v-if="busy" />
  <router-view :layout.sync="layout" v-if="vw" />
  </component> 

</template>
<script>

import { mapState,mapGetters } from 'vuex';
import Spinner from './components/Spinner';

export default {
  data(){
return{
  layout:'div',
  busy:false,
  vw:false
}
  },
  components:{
    Spinner,
  }
  ,
  methods:{
  // ...mapActions('stdMod',['fetchStudents','StudentView']),
 async load(){

       this.busy = true;

     await  this.$store.dispatch('load')
    
    //  await  this.$store.dispatch('stdMod/fetchStudents')
    //  await  this.$store.dispatch('stdMod/StudentView')
    //  await this.$store.dispatch('empMod/fetchData')
      
      this.busy = false;
      this.vw = true;
      
  },
  check_tokin(){

    if(this.token == ""){

     this.$store.dispatch('setCoockie');
  
    }
  }


  }
  ,
  created () {
   
    // this.$store.dispatch('loadCitis'),
    // this.$store.dispatch('loadDistricts'),
    // this.$store.dispatch('loadColleges'),
    this.load();
    this.check_tokin();
   
  },
  computed:{
   ...mapState([
  'students',
  'cities',
  'districts',
  'colleges',
  'levels',
  'buses',
  'nats',     
  'jobs',       
  'workarea',
  'traffic' ,
   'emps',
   'boxes',
   'staticValue',
   'classesyears',
   'roles'
   

  ]),
  ...mapGetters({
    token : "GET_TOKIN"
  })
  
  }
}
</script>
